import type {HtmlLink} from 'src/typings';
import {ngAsync} from '../../utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export class SubSearchLinksDataService {
    public static serviceName = 'subSearchLinksDataService';


    private static GUI_COMPONENTS_SUB_SEARCH_LINKS_ROUTE = 'gui-components/sub-search-links';


    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async fetchLinks(): Promise<HtmlLink[]> {
        return this.ajaxService
            .createRequest(SubSearchLinksDataService.GUI_COMPONENTS_SUB_SEARCH_LINKS_ROUTE)
            .get();
    }
}